import React from 'react';
import { Tooltip } from 'antd';
import cn from 'classnames';
import { ReactComponent as SmartphoneIcon } from '../../../../../resource/SmartphoneIcon.svg';
import { ReactComponent as NotMobileIcon } from '../../../../../resource/NotMobileIcon.svg';
import styles from './AppBlock.module.scss';

const AppBlock = ({ hasApp, rootClassName, ...props }) => {
  return (
    <div
      className={cn(styles.root, rootClassName)}
      {...props}
    >
      <Tooltip
        title={hasApp ? 'Есть приложение' : 'Нет приложения'}
        placement="topLeft"
      >
        {hasApp ? <SmartphoneIcon /> : <NotMobileIcon />}
      </Tooltip>
    </div>
  );
};

export default AppBlock;
